import type * as Blockly from 'blockly/core';
import { BOARD_CONFIG } from '@/(routers)/boards/editor/block/blockConfig';
import {
    expr,
    registerHelperFunction,
    registerSetupCode,
    resolveBoard,
} from '@/(routers)/boards/editor/block/generators/arduino/_gen';

type Position = keyof (typeof BOARD_CONFIG)[keyof typeof BOARD_CONFIG]['pins'];

export function register(gen: any): void {
    gen.forBlock['switch_toggle'] = function (block: Blockly.Block): [string, number] {
        const position = block.getFieldValue('POSITION') as Position;
        const board = resolveBoard(block);
        const pins = BOARD_CONFIG[board].pins[position];
        const first = pins.first;
        const second = pins.second;

        registerHelperFunction(
            'switch_toggle',
            `int _sbeGetToggleSwitch(int firstPin, int secondPin) {\n` +
                `  if (digitalRead(firstPin) == LOW && digitalRead(secondPin) == HIGH) return 2;\n` +
                `  if (digitalRead(firstPin) == HIGH && digitalRead(secondPin) == LOW) return 1;\n` +
                `  return 0;\n` +
                `}`,
        );

        registerSetupCode(String(first), `  pinMode(${first}, INPUT);\n`);
        registerSetupCode(String(second), `  pinMode(${second}, INPUT);\n`);

        return expr(`_sbeGetToggleSwitch(${first}, ${second})`);
    };
}
